import { useState } from 'react';
import PropTypes from 'prop-types';
import { PiArrowRight, PiRepeat, PiTrash } from 'react-icons/pi';
import { TRANSACTION_STATUS } from '../../domain/finance';
import BottomSheet from '../BottomSheet';
import { haptics } from '../../utils/haptics';
import '../RecurringEditScopeSheet/styles.css';

const RecurringDeleteScopeSheet = ({
  item,
  loading = false,
  onClose,
  onDeleteOnlyThis,
  onDeleteThisAndFollowing,
}) => {
  const [scope, setScope] = useState(null);
  const realized = item.status === TRANSACTION_STATUS.PAID
    || item.status === TRANSACTION_STATUS.RECEIVED;

  if (scope) {
    const onlyThis = scope === 'only-this';
    return (
      <BottomSheet
        title="Confirmar exclusão recorrente"
        onClose={loading ? () => {} : () => setScope(null)}
        size="sm"
        footer={(
          <>
            <button
              type="button"
              className="nf-sheet__danger"
              disabled={loading}
              onClick={() => (onlyThis
                ? onDeleteOnlyThis({ allowRealized: realized })
                : onDeleteThisAndFollowing())}
            >
              {loading ? 'Excluindo…' : onlyThis ? 'Excluir esta movimentação' : 'Excluir esta e as próximas'}
            </button>
            <button type="button" className="nf-sheet__secondary" disabled={loading} onClick={() => setScope(null)}>
              Voltar
            </button>
          </>
        )}
      >
        <p className="nf-confirmation-copy">
          {onlyThis
            ? realized
              ? 'Esta movimentação já foi realizada. Excluí-la altera permanentemente seu histórico financeiro.'
              : 'Esta ocorrência deixará de aparecer. As demais movimentações da recorrência serão preservadas.'
            : 'A recorrência será encerrada neste ponto. Movimentações futuras pendentes serão removidas; as já pagas ou recebidas serão preservadas.'}
        </p>
      </BottomSheet>
    );
  }

  return (
    <BottomSheet
      title="Excluir movimentação recorrente"
      onClose={loading ? () => {} : onClose}
      size="md"
      footer={<button type="button" className="nf-sheet__secondary" onClick={onClose} disabled={loading}>Cancelar</button>}
    >
      <div className="recurring-edit-scope">
        <p>O que você deseja excluir?</p>
        <button
          type="button"
          className="recurring-edit-scope__option recurring-edit-scope__option--active"
          onClick={() => { void haptics.selection(); setScope('only-this'); }}
          disabled={loading}
        >
          <span className="recurring-edit-scope__icon" aria-hidden="true"><PiTrash /></span>
          <span><strong>Somente esta ocorrência</strong><small>Excluir apenas esta movimentação.</small></span>
          <PiArrowRight aria-hidden="true" />
        </button>
        <button
          type="button"
          className="recurring-edit-scope__option recurring-edit-scope__option--active"
          onClick={() => { void haptics.selection(); setScope('following'); }}
          disabled={loading}
        >
          <span className="recurring-edit-scope__icon" aria-hidden="true"><PiRepeat /></span>
          <span><strong>Esta e as próximas</strong><small>Excluir esta e as próximas ocorrências.</small></span>
          <PiArrowRight aria-hidden="true" />
        </button>
      </div>
    </BottomSheet>
  );
};

RecurringDeleteScopeSheet.propTypes = {
  item: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onDeleteOnlyThis: PropTypes.func.isRequired,
  onDeleteThisAndFollowing: PropTypes.func.isRequired,
};

export default RecurringDeleteScopeSheet;

